import {
  resolveImageSrcSet,
  resolveImageUrl,
  type ImageFieldValue,
} from '../../../helpers/blocks';

export type PhotoMosaicImage = {
  image?: ImageFieldValue;
  alt?: string;
};

export type PhotoMosaicData = {
  images?: PhotoMosaicImage[];
};

// Cada tile ocupa 20% da viewport (ver _photo-mosaic.scss). Com `sizes` o
// navegador baixa o scale mais próximo desse tamanho real, em vez do `large`
// de 800px para todo mundo — a UNESCO reportou a home lenta por causa disto.
const MOSAIC_SCALES = ['preview', 'teaser', 'large'];
const MOSAIC_SIZES = '20vw';

/**
 * Mosaico full-bleed em 2 fileiras fixas — 5 imagens na primeira linha
 * (20% da largura cada) e 6 na segunda (offset de meio tile, cortadas nas
 * pontas). Total exato: 11 imagens.
 */
const PhotoMosaicView = ({ data }: { data: PhotoMosaicData }) => {
  const images = data.images || [];

  const validImages = images
    .map((item) => ({
      url: resolveImageUrl(item.image, 'large'),
      srcSet: resolveImageSrcSet(item.image, MOSAIC_SCALES),
      alt: item.alt || '',
    }))
    .filter((item) => item.url);

  if (validImages.length === 0) {
    return null;
  }

  // Linhas fixas: 5 na primeira, 6 na segunda (cap em 11 imagens)
  const row1 = validImages.slice(0, 5);
  const row2 = validImages.slice(5, 11);

  return (
    <div className="block-photo-mosaic">
      {[row1, row2].map(
        (row, r) =>
          row.length > 0 && (
            <ul
              className={`photo-mosaic__row photo-mosaic__row--${r + 1}`}
              key={r}
            >
              {row.map((item, i) => (
                <li key={i} className="photo-mosaic__item">
                  <img
                    src={item.url}
                    srcSet={item.srcSet}
                    sizes={item.srcSet && MOSAIC_SIZES}
                    alt={item.alt}
                    loading="lazy"
                    decoding="async"
                    className="photo-mosaic__image"
                  />
                </li>
              ))}
            </ul>
          ),
      )}
    </div>
  );
};

export default PhotoMosaicView;
